import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import isEqual from "lodash/isEqual";
export const onFocusHandler = (focused, setFocused, rtState, rowIndex, columnId) => () => {
  var _context;
  const newFocused = {
    row: rowIndex,
    column: _findIndexInstanceProperty(_context = rtState.allVisibleColumns).call(_context, c => c.id === columnId),
    columnId
  };
  if (!isEqual(focused, newFocused)) {
    setFocused(newFocused);
  }
};
export const isFocused = ({
  row: focusedRow,
  column: focusedColumn
}, rtState, row, columnId) => {
  var _rtState$allVisibleCo;
  return focusedRow === row && ((_rtState$allVisibleCo = rtState.allVisibleColumns[focusedColumn]) === null || _rtState$allVisibleCo === void 0 ? void 0 : _rtState$allVisibleCo.id) === columnId;
};